<template>
  <div class="documentation-detail">
        <h1 class="title">{{detail.title}}</h1>
        <p class="sub-title">
          <span><i class="iconfont icon-caijishijian"></i>发布时间：{{detail.createTime}}</span>
          <span><i class="iconfont icon-caijishijian"></i>发布人：{{detail.username}}</span>
        </p>
        <div class="documentation-content" v-html="detail.content"> </div>
  </div>
</template>
<script>
export default {
    name: "DocumentationList",
    data() {
        return {
            loading: false
        };
    },
    computed: {
        devicePage: {
            get(){
                return this.$store.state.docStore.docTable
            }
        },
        docTable: {
            get(){
                return this.$store.state.docStore.docTable;
            },
            set(){

            }
        }
    },
    methods: {
        fetchPage(){ },
        navigationTo(path) {
            // this.$router.push({ path: path });
        },
        toDetail(item){
            this.$store.commit('documentationData', {
                componentName: 'documentDetail',
                id: item.areaCode
            })
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/documentation/list.vue